import Marquee from "react-fast-marquee";

const ITEMS = [
  "HEAVY DUTY CARDBOARD",
  "PLYWOOD CRATES",
  "PINEWOOD BOXES",
  "EPE FOAM",
  "PU FOAM",
  "XLPE FOAM",
  "ANTI-STATIC",
  "ISPM-15 EXPORT",
  "PAN-INDIA DELIVERY",
  "AIR & SEA FREIGHT"
];

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="marquee"
      className="border-y border-border bg-background py-6 md:py-8 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-3xl md:text-5xl tracking-tight text-foreground px-8">
              {item}
            </span>
            <span className="w-3 h-3 bg-primary rotate-45" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
